import { VDataTable } from "vuetify/lib";
export default {
  name: "BaseVDataTable",
  extends: VDataTable,
  props: {
    mustSort: {
      type: Boolean,
      default: true
    },
    loaderHeight: {
      type: Number | String,
      default: 2
    },
    mobileBreakpoint: {
      type: Number | String,
      default: 0
    }
  }
};
